// extracted by mini-css-extract-plugin
export default {"linha":"title_esq_linha__lHju+","title":"title_esq_title__iTB9r","container":"title_esq_container__i-d-d"};